import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OnboardGuard } from './onboard.guard';
import { AuthGuard } from './auth.guard';
import { RedirectGuard } from './redirect.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    canActivate: [OnboardGuard],
    loadChildren: () => import('./pages/onboarding/onboarding.module').then( m => m.OnboardingPageModule)
  },
  {
    path: 'login',
    canActivate: [RedirectGuard],
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'internal',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/internal/internal.module').then( m => m.InternalPageModule)
  },
  {
    path: 'register',
    canActivate: [RedirectGuard],
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },   {
    path: 'recover-password',
    loadChildren: () => import('./pages/recover-password/recover-password.module').then( m => m.RecoverPasswordPageModule)
  },
  {
    path: 'report',
    loadChildren: () => import('./pages/report/report.module').then( m => m.ReportPageModule)
  },
  {
    path: 'anexo',
    loadChildren: () => import('./pages/anexo/anexo.module').then( m => m.AnexoPageModule)
  },
  {
    path: 'viewer-document',
    loadChildren: () => import('./pages/pdf/pdf.module').then( m => m.PdfPageModule)
  },
  {
    path: 'informe',
    loadChildren: () => import('./pages/informe/informe.module').then( m => m.InformePageModule)
  },
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
